var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"np-fade"}},[_c('div',{staticClass:"np-login-marketing__content np-mb-4",domProps:{"innerHTML":_vm._s(_vm.currentMarketing)}})])}
var staticRenderFns = []

export { render, staticRenderFns }